import { render, staticRenderFns } from "./RfcAlerts.vue?vue&type=template&id=d7385990&"
import script from "./RfcAlerts.vue?vue&type=script&lang=js&"
export * from "./RfcAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports